import React, {Component, useState} from 'react';

import {
    ButtonSet, Button
} from "carbon-components-react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";

export default class extends Component {

    state = {
        form: {
            modal_permission: false,
            id: "",
            user: "",
            permission: "",
            label_permission: ""
        }
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        let {form} = this.props;
        this.setState({
            form: {
                modal_permission: form.modal_permission,
                user: form.user,
                id: form.id,
                permission: form.permission,
                label_permission: form.label_permission
            }
        })
    }

    handleSubmit = async (e) => {
        this.props.onSubmitForm(this.state.form);
    }

    handleCloseModal = async (e) => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_permission: false}
        }));
        this.props.onCloseModal(this.state.form);
    }


    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };

    render() {

        return (
            <>
                <Dialog open={this.state.form.modal_permission} onClose={(e) => this.handleCloseModal(e)}
                        aria-labelledby="form-dialog-title"
                        fullWidth={true}>
                    <DialogTitle id="form-dialog-title"><span
                        style={{color: "#000"}}>Confirmação de usuário</span>
                    </DialogTitle>
                    <DialogContent style={{paddingBottom: "50px"}}>
                            <p><span style={{fontWeight: "900"}}>{this.state.form.user}</span></p>
                            <p>será configurado como Usuário: {this.state.form.label_permission}</p>
                    </DialogContent>
                    <DialogActions style={{padding: "0px"}}>
                        <div style={{width: "100%"}}>
                            <Button style={{width: "50%"}} kind="secondary" onClick={(e) => this.handleCloseModal(e)} isExpressive>
                               Cancelar
                            </Button>
                            <Button style={{width: "50%"}} kind="primary" onClick={(e) => this.handleSubmit(e)} isExpressive>
                                Confirmar
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
